import * as amplitude from '@amplitude/analytics-browser';
import { EventOptions } from '@amplitude/analytics-types';
import { CurrentUserType } from 'types';
import { useAuth } from 'contexts/auth';
import { usePathname } from 'next/navigation';
import { resolveRoute } from 'utils/routes';
import { useCommunity } from 'contexts/communityApp';
import { useTelegramMiniApp } from 'app/_context/TelegramContext';
import { TrackEventType, TrackUserId } from './types';

export const initAmplitude = () => {
  const key = process.env.AMPLITUDE_API_KEY;
  if (!key) {
    console.log('Amplitude API key not found');
    return;
  }

  amplitude.init(key, undefined, {
    transport: 'SendBeacon',
    defaultTracking: {
      pageViews: true,
      sessions: true
    }
  });
};

export const identifyUser = (user: CurrentUserType, platform?: string) => {
  const identifyEvent = new amplitude.Identify();

  identifyEvent.set('name', user?.firstName || '-');

  let options: EventOptions = { user_id: TrackUserId(user?.id) };
  if (platform) options['platform'] = platform;

  amplitude.identify(identifyEvent, options);
};

export const trackOverridePlatforms = (isTelegramMiniApp: boolean) => {
  if (isTelegramMiniApp) {
    return 'telegram-mini-app';
  }
};

export const useTracking = () => {
  const { currentUser } = useAuth();
  const { community } = useCommunity();
  const { isEnabledTWA } = useTelegramMiniApp();
  const pathname = usePathname();

  const trackEvent = (props: TrackEventType) => {
    const path = props.path ?? pathname;
    const route = resolveRoute(path);
    if (!props.user) {
      props.user = currentUser;
    }

    if (!props.options) props.options = {};
    const customPlatform = trackOverridePlatforms(isEnabledTWA);
    if (customPlatform) props.options['platform'] = customPlatform;

    amplitude.track(
      props.name,
      {
        pageName: route?.name,
        pagePath: path,
        community: community?.subdomain,
        ...props.properties
      },
      {
        user_id: props.user ? TrackUserId(props.user.id) : undefined,
        ...props.options
      }
    );
  };

  return {
    trackEvent
  };
};
